function getGraphQlImage(imageObj) {
  if (imageObj && imageObj.localFile && imageObj.localFile.childImageSharp) {
    return imageObj.localFile.childImageSharp.sizes;
  }

  return null;
}

export default getGraphQlImage;
